import React from 'react'

import { Button } from '@wartek-id/button-v1'
import {
  Sheet,
  SheetContent,
  SheetCloseButton,
  SheetOverlay,
  SheetTitle,
} from '@wartek-id/sheet-v1'

import SearchFilterBody from 'app/SearchPage/components/SearchFilterBody'
import { useSearchFilterState } from 'app/SearchPage/hooks/useSearchFilterState'

const SearchFilterSheet = ({ isOpen, onClose }) => {
  const {
    selectedFormats,
    setSelectedFormats,
    selectedTopics,
    setSelectedTopics,
    hasAnyFilterSelected,
    submitFilterHandler,
    resetFilterHandler,
    clickOptionHandler,
    searchFiltersData,
  } = useSearchFilterState({ isOpen, onClose })

  return (
    <Sheet
      isOpen={isOpen}
      onClose={onClose}
      position="bottom"
      sheetSize="xl"
      autoFocus={false}
      returnFocus={false}
    >
      <SheetOverlay />

      <SheetContent className="max-w-xl m-auto">
        <SheetTitle bold>Pilih kategori</SheetTitle>
        <SheetCloseButton onClick={onClose} />
        <div className="p-4 pb-28">
          <SearchFilterBody
            selectedFormats={selectedFormats}
            selectedTopics={selectedTopics}
            onFormatsChange={setSelectedFormats}
            onTopicsChange={setSelectedTopics}
            onCheckboxChange={clickOptionHandler}
            searchFiltersData={searchFiltersData}
          />
        </div>
        <div className="absolute bottom-0 w-full p-4 space-y-2 bg-white">
          <Button color="blue" fullWidth onClick={submitFilterHandler}>
            Tampilkan hasil
          </Button>
          <Button
            color="white"
            fullWidth
            disabled={!hasAnyFilterSelected}
            onClick={resetFilterHandler}
          >
            Reset
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  )
}

export default SearchFilterSheet
